

import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const saveProfessionalExperience = async (token: any, profesionalExperienceData: any) => {
  try {
    const response = await axios.post(
        `${API_BASE_URL}/SaveProfessionalExperience`,
        profesionalExperienceData,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting Professional Experience:", error);
    throw error;
  }
};
